import styled from 'styled-components';

import { translate } from '@vimeo/i18n-runtime';

import T from '../../../translate';
import { useRouterPath } from '../../hooks';
import { useGlobalStore } from '../../state/globalStore';
import { Padding } from '../../styles/commonStyle';
import { KEY_CODES, PREVIEW_TYPE } from '../../utils/constants';
import { EventDate } from '../common/EventDate';
import { Alignment, WrapperBox } from '../previewStyles';

const RegistrationFull = () => {
  const leadCaptureProperties = useGlobalStore((state) => state.leadCapture);
  const {
    logo,
    alignment,
    nonEditableTextStyle: { alreadyRegistered: alreadyRegisteredStyle },
  } = leadCaptureProperties;
  const {
    entity: { title: eventTitle },
  } = useGlobalStore((store) => store);
  const { onPreviewChange } = useRouterPath();

  return (
    <Alignment align={alignment} addPadding>
      <WrapperBox paddingBottom={98}>
        {logo.isActive && (
          <a
            {...(logo.isLinkActive &&
              logo.customLink?.length > 0 && { href: logo.customLink, target: '_blank' })}
          >
            <Logo src={logo.url} />
          </a>
        )}
        <Title>
          <div>{T.RegistrationFullMessage}</div>
          <EventTitle>{eventTitle}</EventTitle>
        </Title>
        <Padding top={16} left={4} right={4}>
          <EventDate />
        </Padding>
        <StyledLoginTextWrapper>
          <StyledLoginText color={alreadyRegisteredStyle.color}>
            {translate({
              singular: 'Already registered? {LINK}Sign in{/LINK}',
              replacements: {
                LINK: (text: string) => (
                  <Pointer
                    tabIndex={0}
                    onKeyPress={(e) =>
                      e.key === KEY_CODES.ENTER && onPreviewChange(PREVIEW_TYPE.LOGIN_SCREEN)
                    }
                    onClick={() => onPreviewChange(PREVIEW_TYPE.LOGIN_SCREEN)}
                  >
                    {text}
                  </Pointer>
                ),
              },
            })}
          </StyledLoginText>
        </StyledLoginTextWrapper>
      </WrapperBox>
    </Alignment>
  );
};

const Logo = styled.img`
  max-height: 56px;
  margin-bottom: 16px;
  margin-left: 8px;
  margin-right: 8px;
`;

const Pointer = styled.u`
  cursor: pointer;
`;

const StyledLoginTextWrapper = styled.div`
  padding: 0 4px;
  margin-top: 16px;
`;

const StyledLoginText = styled.div<{ color: string }>`
  padding-top: 8px;
  font-size: 12px;
  font-weight: 400;
  color: ${({ color }) => color};
`;

const Title = styled.div`
  font-size: 36px;
  font-weight: 700;
  line-height: 41.7px;
  letter-spacing: -1.2px;
`;

const EventTitle = styled.div`
  margin-top: 8px;
  font-size: 29px;
  font-weight: 400;
`;

export default RegistrationFull;
